import { Injectable } from '@angular/core';
import { ModuleType } from '@contracts';
import { AuthService } from '@core';
import { map, switchMap, tap } from 'rxjs';

@Injectable()
export class LoginFacade {
  constructor(private readonly authService: AuthService) {}

  login(email: string, password: string) {
    return this.authService.login({ email, password }).pipe(
      map((res) => {
        const status = res.meta.response_code;
        const data = res.meta.response_data;
        const user = data.user;

        if (status !== 20000) {
          throw new Error('LOGIN_FAILED');
        }

        return {
          data,
          user,
          requiresPasswordSetup: user?.is_set_password === false,
        };
      }),
    );
  }

  submitResetPassword(
    email: string,
    oldPassword: string,
    newPassword: string,
    module: ModuleType,
  ) {
    return this.authService
      .setPassword({
        email,
        old_password: oldPassword,
        new_password: newPassword,
      })
      .pipe(
        tap((res) => {
          if (res.meta.response_code !== 20000) {
            throw new Error('RESET_PASSWORD_FAILED');
          }
        }),
        switchMap(() =>
          this.authService.login({ email, password: newPassword }),
        ),
        tap((res) => {
          if (res.meta.response_code !== 20000) {
            throw new Error('LOGIN_FAILED');
          }
        }),
        tap((res) => {
          this.authService.saveSession(res.meta.response_data, module);
        }),
      );
  }

  completeLogin(data: { token?: string; user: any }, module: ModuleType) {
    this.authService.saveSession(data, module);
  }
}
